import type { ReactNode } from "react";
import type { ChatMessage } from "@/sdk";
import type { SalesDisclosureAttributes } from "@/sdk/agent/chat/types";
import { SalesDisclosureCard } from "./SalesDisclosureCard";

/**
 * Renders the appropriate EXTRA component for a given message type.
 * Centralized place to handle all special message type rendering.
 * Add new message type rendering logic here instead of in the MessageListItem component.
 */
export function renderMessageTypeExtraComponent(message: ChatMessage): ReactNode | null {
    switch (message.messageType) {
        case "salesDisclosure":
            return <SalesDisclosureCard attributes={message.attributes as unknown as SalesDisclosureAttributes} />;
        case "text":
        case "media":
        default:
            return null;
    }
}
